import { ProviderDetailPage } from '../ProviderDetailPage';
import type { ProviderMeta } from '../ProviderDetailPage';

const META: ProviderMeta = {
  slug: 'glovo',
  name: 'Glovo',
  tagline: 'Glovo courier network integration for on-demand delivery',
  colorClass: 'bg-[var(--chart-3)] text-white',
  initial: 'G',
  webhookPath: '/webhooks/delivery/glovo',
  feeNote:
    'Glovo charges a variable rate based on city-level pricing models. In Nairobi, base fees ' +
    'range from KES 60–120, with per-km rates around KES 25–35/km. Final rates depend on the ' +
    'Glovo Partner Programme tier negotiated. Chekit retains its standard delivery service fee ' +
    '(10% or configured %) on top of any third-party payout.',
};

export const GlovoConfigPage = () => <ProviderDetailPage meta={META} />;
